// extracted by mini-css-extract-plugin
export default {"Table":"Table_Table__N8Kmj","Compact":"Table_Compact__2kHbp"};